module.exports = __webpack_public_path__ + "assets/media/m-1.c5e30955.svg";